import { ChangeDetectorRef, Component, OnInit, inject, DestroyRef } from '@angular/core';
import { AuthService } from '@core/auth/auth.service';
import { IUser } from '@data/schema';
import { Router, RouterLink } from '@angular/router';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { environment } from '@env';
import { SvgIconComponent } from 'angular-svg-icon';

import { RemoveWhiteSpacePipe } from '@shared/pipes/removewhitespaces/removewhitespaces.pipe';
import { takeUntilDestroyedSafe } from '@core/helpers/take-until-destroyed-safe';

interface SettingsSubmenuItem {
  title: string;
  url: string;
  icon?: string;
  notification?: boolean;
}
interface SettingsMenuItem {
  title: string;
  url: string;
  icon?: string;
  notification?: boolean;
  submenu?: SettingsSubmenuItem[];
}

@Component({
    selector: 'app-sidebar-settings',
    templateUrl: './sidebar-settings.component.html',
    styleUrls: ['./sidebar-settings.component.scss'],
    imports: [RouterLink, SvgIconComponent, RemoveWhiteSpacePipe, TranslateModule]
})
export class SidebarSettingsComponent implements OnInit {
  private readonly destroyRef = inject(DestroyRef);

  private readonly authService = inject(AuthService);
  private readonly cd = inject(ChangeDetectorRef);
  private router = inject(Router);
  private readonly translate = inject(TranslateService);

  user!: IUser;

  electron = environment.electron;

  public settingsMenuItems: SettingsMenuItem[] = [];

  logOut(event: Event) {
    event.preventDefault();
    event.stopPropagation();
    this.authService.logOut();
    return false;
  }

  isCurrent(menuItem: SettingsMenuItem): boolean {
    const currentUrl = this.router.url;
    const menuItemUrl = menuItem.url;
    const parentUrl = menuItemUrl.endsWith('s') ? menuItemUrl.slice(0, -1) : menuItemUrl;

    if (currentUrl.endsWith('/documentations') && menuItemUrl === '/projects') {
      return true;
    }

    if (currentUrl === menuItemUrl || currentUrl === parentUrl) {
      return true;
    }

    if (currentUrl.startsWith(parentUrl)) {
      const nextChar = currentUrl.charAt(parentUrl.length);

      if (nextChar === '/' || nextChar === '') {
        return true;
      }
    }

    return false;
  }

  ngOnInit(): void {
    this.authService
      .getUser()
      .pipe(takeUntilDestroyedSafe(this.destroyRef))
      .subscribe((user) => {
        this.user = user;
        this.settingsMenuItems = [
          {
            title: this.translate.instant('sidebar-settings.message'),
            icon: 'notification',
            url: '/user/' + user.id + '/messages',
            notification: true,
          },
        ];
        this.cd.detectChanges();
      });
  }
}
